import type { PageCard } from '@/play/pageTypes'
import { DripWall2CardArt } from './CardArt'

/** What the home screen shows for this page; the page itself is ./index.ts, loaded when it opens. */
export const card: PageCard = {
  id: 'drip-wall-2',
  number: 37,
  title: 'Drip wall 2',
  question: 'Do drips that come from how heavily you paint (slow or pressed: thick and drippy; fast: thin and dry), on strokes that taper to points, feel more alive than evenly spaced drips?',
  status: 'open',
  // Version 2 of 030 Drip wall: one home card (this one), flipped between in the settings panel.
  versionOf: 'drip-wall',
  accent: '#ffe0ef',
  CardArt: DripWall2CardArt,
}
